import url from '@/creditflowresearch/infrastructure/url';
import staticUrls from '@finsight/urls/static';

const getStatsMetaSchema = (pathname: string, products: string, regions: string) => {
  const pageName = `${ regions } ${ products } New Issue Statistics`;
  const pageDescription = `View and analyze historical new issue volume and deal count statistics for the ${ regions } ${ products } market.`;

  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    url: url.getUrl(pathname),
    name: pageName,
    description: pageDescription,
    keywords: [
      'new issue stats',
      'fixed income',
      'structured finance',
      'volume data',
      `${ products } market`,
      regions,
    ],
    hasPart: {
      '@type': 'Dataset',
      name: `Historical Data: ${ pageName }`,
      description: `A dataset of historical new issue volume and number of deals for the ${ regions } ${ products } market.`,
      license: staticUrls.getTermsOfUseUrl(),
      isAccessibleForFree: false,
      cssSelector: '[data-test="articlesDataTableContainer"]',
    },
  };
};

export default getStatsMetaSchema;
